<template>
    <div>
        <div class="text-center w-full sm:w-2/3 mx-auto">
            <h3 v-text="$t('SUBSCRIPTION_DROP_DOWN_WHATS_IN_THE_BOX')"></h3>
            <h5 class="uppercase" v-text="title"></h5>
            <div class="flex items-center justify-between">
                <div class="accountMyBoxDateToggle__ButtonContainer">
                    <button
                        v-if="canDecrement"
                        class="accountMyBoxDateToggle__icon accountMyBoxDateToggle__icon--previous"
                        @click="$store.dispatch('cms/decrementActiveScheduleWeek')">
                    </button>
                </div>
                <div class="">
                    <p class="m-0" v-text="dateString"></p>
                </div>
                <div class="accountMyBoxDateToggle__ButtonContainer">
                    <button
                        v-if="canIncrement"
                        class="accountMyBoxDateToggle__icon accountMyBoxDateToggle__icon--next"
                        @click="$store.dispatch('cms/incrementActiveScheduleWeek')">
                    </button>
                </div>
            </div>
            <transition name="transitionFade">
                <button v-if="canOptIntoDelivery"
                    class="btn btn--primary btn--half opt-in-button"
                    @click="createOptInOrder()"
                    :disabled="processingOptIn"
                    v-html="$t('SUBSCRIPTION_DROP_DOWN_OPT_IN')">
                </button>
            </transition>

            <p v-if="error" class="error" v-html="error"></p>

            <transition name="transitionFade">
                <p v-if="success" v-html="success"></p>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDate, isDateAfter } from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';
import ScheduledOrderService from '@/services/subscriptions/Subscriptions/ScheduledOrderService';

let scheduledOrderService = new ScheduledOrderService();

export default {
    name: 'DateToggle',
    data() {
        return {
            error: null,
            success: null,
            processingOptIn: false,
        };
    },
    computed: {
        ...mapGetters({
            date: 'cms/getActiveScheduleDeliveryDate',
            canDecrement: 'cms/canDecrementActiveSchedule',
            canIncrement: 'cms/canIncrementActiveSchedule',
            activeWeekStart: 'cms/getActiveWeekStart',
            deliveries: 'scheduledOrder/getDeliveries',
            subscription: 'subscription/getActiveSubscription',
        }),
        dateString() {
            return this.date ? formatDate(this.date, Dates.DAY_DATE_MONTH) : null;
        },
        canOptIntoDelivery() {
            if (this.date) {
                const delivery = this.deliveries.find((item) => item.datetime === formatDate(this.date, Dates.DASHED_YEAR_MONTH_DAY));
                return delivery && !delivery.delivery_scheduled && !delivery.scheduled_order_id && !delivery.cut_off_expired;
            }
        },
        title() {
            let title = isDateAfter(new Date(), this.date) ? this.$t('SUBSCRIPTION_DROP_DOWN_DELIVERY_ON') : this.$t('SUBSCRIPTION_DROP_DOWN_DELIVERING_ON');
            title = this.canOptIntoDelivery ? this.$t('SUBSCRIPTION_DROP_DOWN_DELIVERY_OPT_IN') : title;
            this.$emit('update-title', title);
            return title;
        },
    },
    methods: {
        createOptInOrder() {
            this.error = null;
            this.processingOptIn = true;
            scheduledOrderService.createOptInOrder({
                subscriptionId: this.subscription.id,
                deliveryDate: formatDate(this.date, 'yyyy-MM-dd'),
            }).then(() => {
                this.$store.dispatch('subscription/fetchAllSubscriptions', true)
                    .then(() => this.success = this.$t('SUBSCRIPTION_DROP_DOWN_OPT_IN_SUCCESS'));
            }).catch(() => {
                this.error = this.$t('SUBSCRIPTION_DROP_DOWN_OPT_IN_ERROR');
            }).finally(() => {
                this.processingOptIn = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    .opt-in-button {
        padding: 8px;
        margin: 8px;
    }
</style>
